module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"traffic":"来店客数","trafficTrend":"来店客数傾向","Mon":"月","Tue":"火","Wed":"水","Thu":"木","Fri":"金","Sat":"土","Sun":"日","Current":"選択期間","Compared":"比較期間","selectedperiod":"選択期間","compareperiod":"比較期間","rain":"雨","temperature":"気温","trendTooltip":"選択期間と比較期間の来店客数の推移を表すグラフです。選択日数を一日にすることで時間帯別のグラフが表示されます","trendTooltip2":"選択日数を一日にすることで時間帯別のグラフが表示されます。"}}')
  delete Component.options._Ctor
}
